import React from 'react';
import { styled } from '@teko/ui';
import Link from 'next/link';
import { ListTile } from '../ListTile/ListTile.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const List = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
`;
const StyledListTile = styled(ListTile)(({ theme, active, hover = true, cursor = true }) => `
    cursor: ${cursor ? "pointer" : "default"};
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 4px 0;
    margin: 8px 0;
    background: unset;

    ${active ? `
      font-weight: 700 !important;
      color: ${theme == null ? void 0 : theme.brand.primary} !important;
      > :not(.noti) path {
        fill: ${theme == null ? void 0 : theme.brand.primary};
      }
      > .noti path{
        stroke: ${theme == null ? void 0 : theme.brand.primary};
      }
    ` : hover ? `
      &:hover, .active {
        font-weight: 700 !important;
        color: ${theme == null ? void 0 : theme.brand.primary} !important;
        > :not(.noti) path {
          fill: ${theme == null ? void 0 : theme.brand.primary};
        }
        > .noti path{
          stroke: ${theme == null ? void 0 : theme.brand.primary};
        }
      }` : `&:hover { background-color: unset; }`}
  `);
const Divider = styled.li`
  background-color: #e0e0e0;
  width: 100%;
  height: 1px;
  list-style: none;
`;
const StyledA = styled.a`
  text-decoration: none;
`;
const renderNode = (props) => {
  const {
    icon,
    text,
    href,
    fallbackHref,
    children = [],
    activeHref,
    index
  } = props;
  const nodeHasChildren = !!children.length;
  const node = /* @__PURE__ */ React.createElement(StyledListTile, __spreadValues({
    leading: icon,
    title: text,
    active: !nodeHasChildren && (href === activeHref || !!index && !!href && !!(activeHref == null ? void 0 : activeHref.startsWith(href)) || fallbackHref === activeHref)
  }, nodeHasChildren ? { cursor: false, hover: false } : {}));
  return !!href ? /* @__PURE__ */ React.createElement(Link, {
    href,
    legacyBehavior: true
  }, /* @__PURE__ */ React.createElement(StyledA, null, node)) : node;
};
const SideNav = (_a) => {
  var _b = _a, {
    navItems,
    activeHref,
    parentMenuHighlight = true
  } = _b, props = __objRest(_b, [
    "navItems",
    "activeHref",
    "parentMenuHighlight"
  ]);
  return /* @__PURE__ */ React.createElement(List, __spreadValues({}, props), navItems.map((_a2, index) => {
    var _b2 = _a2, { children, href } = _b2, rest = __objRest(_b2, ["children", "href"]);
    return /* @__PURE__ */ React.createElement(React.Fragment, {
      key: index
    }, renderNode(__spreadProps(__spreadValues({}, rest), {
      href: !parentMenuHighlight && !!(children == null ? void 0 : children.length) ? "" : href,
      children,
      activeHref,
      index
    })), !!(children == null ? void 0 : children.length) && (children == null ? void 0 : children.map((item, itemIndex) => /* @__PURE__ */ React.createElement(React.Fragment, {
      key: `${index}-${itemIndex}`
    }, renderNode(__spreadProps(__spreadValues({}, item), {
      activeHref,
      index: itemIndex
    }))))), index === navItems.length - 1 && /* @__PURE__ */ React.createElement(Divider, null));
  }));
};

export { SideNav };
